module.exports = __webpack_public_path__ + "static/404-ce247218f4fc8acb55dce84035006f6b.png";